import { IMedicalPlanRatesDrawerInfo } from '.';
import PrecisionService from '@services/PrecisionService';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

export function LookupToList(data: any) {
  const medicalPlanRatesEnums: Record<string, Record<string, string>> = {};

  medicalPlanRatesEnums['medicalPlanClasses'] = lookupListAsRecordObject(
    data?.Core?.lookups?.medicalPlanClasses
  );

  medicalPlanRatesEnums['medicalLevels'] = lookupListAsRecordObject(
    data?.Core?.lookups?.medicalLevels
  );

  medicalPlanRatesEnums['coNSSFOptions'] = enumListAsRecordObject(
    data?.Core_CoNSSFOptions?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );

  medicalPlanRatesEnums['tpaApplicableOnOptions'] = enumListAsRecordObject(
    data?.Core_TPAApplicableOnOptions?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );

  return medicalPlanRatesEnums;
}

export function graphqlToMedicalPlanRatesInfo(
  data: any
): IMedicalPlanRatesDrawerInfo {
  const medicalPlanRates =
    data?.PlanConfigManagement?.entities?.planSpecificMedical?.views
      ?.PlanConfigManagement_all?.properties;

  const PolicyCoverData =
    medicalPlanRates?.PolicyCoverID?.views?.PlanConfigManagement_all
      ?.properties;

  return {
    clauseReferenceTitle: `${medicalPlanRates?.ClauseID?.views?.PlanConfigManagement_all?.properties?.ExternalCode} - ${medicalPlanRates?.ClauseID?.views?.PlanConfigManagement_all?.properties?.Name}`,
    policyCover: medicalPlanRates?.PolicyCoverID?.id,
    policyCoverTitle: `${PolicyCoverData?.ExternalCode} - ${PolicyCoverData?.Name}`,
    nbOfAdherent: medicalPlanRates?.NbOfAdherent,
    class: medicalPlanRates?.Class?.Id,
    ageFrom: medicalPlanRates?.AgeFrom,
    ageTo: medicalPlanRates?.AgeTo,
    coNssf: medicalPlanRates?.CoNssf,
    netPremium: medicalPlanRates?.NetPremium,
    tpaFeesPercentage: medicalPlanRates?.TPAFeesPercentage
      ? PrecisionService.multiplyBy100(
          medicalPlanRates?.TPAFeesPercentage
        ).toString()
      : '',
    tpaFeesApplicableOn: medicalPlanRates?.TPAApplicableOn,
    minTPAFees: medicalPlanRates?.MinTPAFees,
    maxTPAFees: medicalPlanRates?.MaxTPAFees,
    isMain: medicalPlanRates?.IsMain,
    isMandatory: medicalPlanRates?.IsMandatory,
    isEditable: medicalPlanRates?.IsEditable,
    level: medicalPlanRates?.Level?.Id,
    sumInsured: medicalPlanRates?.SumInsured,
    sumInsuredIsAdditive: medicalPlanRates?.SumInsuredIsAdditive,
    excessOnClaimType: medicalPlanRates?.ExcessOnClaimType,
    excessOnClaimAmount: medicalPlanRates?.ExcessOnClaimAmount,
    excessOnClaimPercentage: medicalPlanRates?.ExcessOnClaimPercentage
      ? PrecisionService.multiplyBy100(
          medicalPlanRates?.ExcessOnClaimPercentage
        ).toString()
      : '',
    excessOnClaimDays: medicalPlanRates?.ExcessOnClaimDays,
    clauseReference: medicalPlanRates?.ClauseID?.id || null,

    tpaType: medicalPlanRates?.TPAType,
    tpaAmount: medicalPlanRates?.TPAAmount,
  };
}

export function extractPolicyCovers(data: any) {
  const policyCoverList: Record<string, string> = {};

  data.PlanConfigManagement.queries.allPolicyCoverList.forEach(
    (element: {
      planConfigManagement_PolicyCover_Id: string;
      planConfigManagement_PolicyCover_Name: string;
      planConfigManagement_PolicyCover_ExternalCode: string;
    }) => {
      policyCoverList[element.planConfigManagement_PolicyCover_Id] =
        `${element.planConfigManagement_PolicyCover_ExternalCode} - ${element.planConfigManagement_PolicyCover_Name}`;
    }
  );

  return policyCoverList;
}

export function extractClauses(data: any) {
  const clauses: Record<string, string> = {};

  data?.PlanConfigManagement?.queries?.allClauseList?.forEach(
    (element: {
      planConfigManagement_Clause_Id: string;
      planConfigManagement_Clause_ExternalCode: string;
      planConfigManagement_Clause_Name: string;
    }) => {
      clauses[element.planConfigManagement_Clause_Id] =
        `${element.planConfigManagement_Clause_ExternalCode} - ${element.planConfigManagement_Clause_Name}`;
    }
  );

  return clauses;
}
